import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { persistor } from 'src/store/Store';

const initialState = {
    address: null,
    certificate: null,
    dateAdded: null,
    dateOfIssue: null,
    email: null,
    gender: null,
    //id: null,
    lastLessonEntered: null,
    lastWorksEntered: null,
    learnedLanguage: null,
    levelDetection: null,
    name: null,
    originalLanguage: null,
    role: null,
    surname: null,
    telephone: null,
    token: null,
};


export const LoginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        getUser: (state, action) => {

            return {
                ...state,
                ...action.payload
            };
        },
    },
});

export const getUserData = (type, email, password) => async (dispatch) => {
    console.log(type, email, password);
    if (type == 'USER') {
        axios
            .post("https://backend.sophtomeng.com/auth/login", {
                email: email,
                password: password,
            })
            .then((response) => {
                const filteredData = { ...response.data };
                delete filteredData.id
                dispatch(getUser(
                    filteredData
                ))
            }
            )
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    }
}

export const verifyCredentials = async (type, email, token) => {
    console.log({
        email: email,
        token: token,
    });
    if (type === 'USER') {
        const body = {
            email: email,
            token: token,
        };
        try {
            const response = await axios.post("https://backend.sophtomeng.com/auth/validate", body);
            if (response.status === 200) {
                return true; 
            } else {
                return false; 
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                persistor.purge();
                alert("Unauthorized Access Please Log In Again");
                window.location.replace("http://localhost:3000/auth/login");
            }
            return false; // HTTP isteğinde hata oluştu
        }
    }
}


export const {
    getUser,
} = LoginSlice.actions;

export default LoginSlice.reducer;
